<template>
  <div class="conten bg-f6">
    <section>
      <p class="row bg-white cen-between padding0-15 gray-2 payTitle">
        <span class="ft16">{{ orderInfo.ctitle }} x1</span>
        <span class="ft14 red">¥{{ orderInfo.coursePrice }}</span>
      </p>
      <div class="lineF4"></div>
      <p class="couponBox bg-white padding0-15 gray-2 row cen-between">
        <span @click="selectCp" class="ft16">
          优惠券
          <span v-if="orderInfo.couponNum" class="payImg ilbk relative">
            <img src="../../assets/imgs/payImg.png" alt="" />
            <span class="absolute couponNum ft10 white text-center"
              >{{ orderInfo.couponNum }}张可用</span
            >
          </span>
        </span>

        <span @click="selectCp" v-if="orderInfo.coupon" class="ft14 red"
          >-¥{{ orderInfo.coupon }}</span
        >
        <span v-else class="ft14 gray-6">暂无可用</span>
      </p>
      <div class="lineF4"></div>
      <div class="padding15 ft14 lineHe14 bg-white">
        <p class="ft16 gray-2 margin20-bottom">费用明细</p>
        <p class="gray-6 row cen-between margin15-bottom">
          <span>课程金额</span>
          <span>¥{{ orderInfo.coursePrice }}</span>
        </p>
        <p class="gray-6 row cen-between margin15-bottom">
          <span>优惠金额</span>
          <span>¥{{ orderInfo.coupon }}</span>
        </p>
        <p class="gray-6 row cen-between">
          <span>实际支付</span>
          <span>¥{{ orderInfo.discountPrice }}</span>
        </p>
      </div>
      <div class="lineF4"></div>
      <div class="ft14 lineHe14 bg-white">
        <p class="ft16 padding15 gray-2">支付方式</p>
        <div
          @click="payClick(1)"
          class="paylist gray-6 row cen-between padding0-15"
          :class="{ bgff: payFlag == 1 }"
        >
          <span class="row cen-start">
            <span class="iconBox ilbk">
              <img src="../../assets/imgs/wx.png" alt="" />
            </span>
            <span class="ft14 padding15-left">微信支付</span>
          </span>
          <span class="radioImg ilbk">
            <img
              v-if="payFlag == 1"
              src="../../assets/imgs/se_btn.png"
              alt=""
            />
            <img v-else src="../../assets/imgs/btn.png" alt="" />
          </span>
        </div>
        <div
          v-if="jsFlag"
          @click="payClick(2)"
          class="paylist defbg row cen-between padding0-15"
          :class="{ bgff: payFlag == 2 }"
        >
          <span class="row cen-start">
            <span class="iconBox ilbk">
              <img src="../../assets/imgs/zfb.png" alt="" />
            </span>
            <span class="ft14 padding15-left">支付宝支付</span>
          </span>
          <span class="radioImg ilbk">
            <img
              v-if="payFlag == 2"
              src="../../assets/imgs/se_btn.png"
              alt=""
            />
            <img v-else src="../../assets/imgs/btn.png" alt="" />
          </span>
        </div>
      </div>

      <div class="fixBox"></div>
      <div
        class="fixedBtn bg-white row cen-between padding15-left padding15-bottom"
      >
        <div class="orangered">
          <span class="ft14 gray-6 padding5-right">实付</span>
          <span class="ft12">¥</span>
          <span class="ft22">{{ orderInfo.discountPrice }}</span>
        </div>
        <div class="row text-center" @click="toBuy">
          <span class="ilbk buyBtn ft16 white">立即购买</span>
        </div>
      </div>
    </section>
    <Loading v-if="awitType" />
  </div>
</template>

<script>
/* eslint-disable */
import Loading from "@/views/common/loading";
import {
  generateOrder,
  toPay,
  getWxConfig,
  getOpenid,
} from "@/model/pay/payServer";
import { CacheModule, getAppClient } from "../../utils/commonUtils";
import { store, mutations } from "../../observable/store";

export default {
  name: "pay",
  components:{
    Loading
  },
  data() {
    return {
      awitType:true,
      payFlag: 1,
      orderInfo: {
        ctitle: "",
        discountPrice: 0,
      },
      jsFlag: true,
      wxPay: {
        appid: this.GLOBAL.wxPay.appid, // 测试
        redirectUri: this.GLOBAL.formal
          ? "m.xzjy365.com"
          : "mceshi.xzjy365.com",
      },
      cid: "",
    };
  },
  created() {
    let wxHerf = window.location.href;
    let code = wxHerf.split("?")[1] || wxHerf.split("?")[0] || "";
    if (code) {
      let codeArr = code.split("&");
      let codeParam = {};
      for (var i = 0; i < codeArr.length; i++) {
        codeParam[codeArr[i].split("=")[0]] = codeArr[i].split("=")[1];
      }
      if (codeParam.code) {
        this.awitType = false
        let parmer = {
          appid: this.wxPay.appid, //公众号appid
          code: codeParam.code, //code码
          towDomain: this.wxPay.redirectUri, //域名
        };
        getOpenid(parmer)
          .then((data) => {
            if (data && data.data.openid) {
              mutations.getOpenid(data.data.openid);
            }
          })
          .catch(() => {});
      } else {
        if (store.openid == "0" && getAppClient() == "JSAPI") {
          let url =
            "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
            this.wxPay.appid +
            "&redirect_uri=" +
            encodeURIComponent(location.href) +
            "&response_type=code&scope=snsapi_base&state=STATE&connect_redirect=1#wechat_redirect";
          window.location.replace(url);
        }
      }
    }
    if (getAppClient() == "JSAPI") {
      this.jsFlag = false;
      let data = {
        url: encodeURIComponent(location.href.split("#")[0]),
        appId: this.wxPay.appid,
      };
      getWxConfig(data).then((res) => {
        let data = res.data;
        if (data && data.timeStamp) {
          window.wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: this.wxPay.appid, // 必填，公众号的唯一标识
            timestamp: data.timeStamp, // 必填，生成签名的时间戳
            nonceStr: data.nonce_str, // 必填，生成签名的随机串
            signature: data.signature, // 必填，签名，见附录1
            jsApiList: [
              "checkJsApi",
              "onMenuShareAppMessage",
              "onMenuShareTimeline",
              "hideMenuItems",
              "chooseImage",
              "uploadImage",
            ], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          this.awitType = false
        }
      });
    }
    if (!CacheModule.get("loginPhone")) {
      this.$router.push({
        path: "/details",
        query: {
          cid: this.$route.query.cid,
        },
      });
      return;
    }
    let couponParme = CacheModule.getSessionStorage("couponParme");
    let query = this.$route.query;
    if (query.type == "buy" || query.type == "group") {
      this.awitType = false
      this.orderInfo.ctitle = query.ctitle;
      this.orderInfo.id = query.id;
      this.orderInfo.coursePrice = query.coursePrice;
      this.orderInfo.coupon = query.coupon;
      this.cid = query.cid;
      let data = {
        pid: query.cid,
        paymentway: query.type == "buy" ? 1 : 2,
        orderGroupId: query.belongGroupId == undefined ? null : query.belongGroupId,
      };
      this.Api({
        url: "api/addDatumOrder",
        method: "POST",
        data,
      })
        .then((res) => {
          this.orderInfo.ctitle = res.data.ctitle;
          this.orderInfo.id = res.data.cid;
          this.orderInfo.discountPrice = res.data.discountPrice;
          this.orderInfo.coupon = res.data.coupon;
          this.orderInfo.coursePrice = res.data.practicalPrice;
          this.orderInfo.orderNumber = res.data.orderNumber;
          this.orderInfo.userCourseId = res.data.userCourseId;
          this.orderInfo.orderGroupId = res.data.orderGroupId;
          this.orderInfo.uid = res.data.uid;
          this.orderInfo.state = res.data.state
        })
        .catch((res) => {
          this.orderInfo.ctitle = res.data.ctitle;
          this.orderInfo.id = res.data.cid;
          this.orderInfo.discountPrice = res.data.discountPrice;
          this.orderInfo.coupon = res.data.coupon;
          this.orderInfo.coursePrice = res.data.practicalPrice;
          this.orderInfo.orderNumber = res.data.orderNumber;
          this.orderInfo.userCourseId = res.data.userCourseId;
          this.orderInfo.orderGroupId = res.data.orderGroupId;
          this.orderInfo.uid = res.data.uid;
          this.orderInfo.state = res.data.state
        });
    } else {
      generateOrder({ cid: this.$route.query.cid,acttypeid:this.$route.query.acttypeid * 1 }).then((res) => {
        this.awitType = false
        this.orderInfo = res.data;
        if (couponParme) {
          this.orderInfo.id = couponParme.id;
          this.orderInfo.coupon = couponParme.amount;
          this.orderInfo.coursePrice =
          this.orderInfo.discountPrice - couponParme.amount;
        }
      });
    }
  },
  computed: {
    wxOpendId() {
      return store.openid;
    },
  },
  methods: {
    toBuy() {
      if(this.orderInfo.state == 2){
        this.$router.push({
          path: "/classPayResult",
          query: {
            orderNumber: this.orderInfo.orderNumber,
            type: "1",
            cid:this.orderInfo.id
          },
        });
        return false
      }
      this.awitType = true
      let query = this.$route.query;
      if (query.free != undefined) {
        this.$toast("购买成功");
        window.location.href = "javascript:history.go(-1)";
      }
      if (query.type == "buy" || query.type == "group") {
        let data = {
          orderNumber: this.orderInfo.orderNumber,
          pid: getAppClient() == "JSAPI" ? "3" : this.payFlag, //支付方式 1.微信/2.支付宝
        };
        if (getAppClient() == "JSAPI") {
          data.openid = this.wxOpendId;
        }
        if (query.belongGroupId != undefined) { // 如果归属的id不为空
          data.belongGroupId = query.belongGroupId;
        }
        this.Api({
          url: "api/toPayDatumOrder",
          method: "POST",
          data,
        }).then((res) => {
          this.awitType = false
          if (getAppClient() == "JSAPI") {
            let _this = this;
            let dataTow = res.data;
            wx.ready(function () {
              wx.chooseWXPay({
                timestamp: dataTow.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: dataTow.nonceStr, // 支付签名随机串，不长于 32 位
                package: dataTow.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: dataTow.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: dataTow.paySign, // 支付签名
                success: function () {
                  _this.$router.push({
                    path: "/classPayResult",
                    query: {
                      isPay: true,
                      cid: _this.cid,
                      belongGroupId: _this.$route.query.belongGroupId,
                      type: _this.$route.query.type,
                      orderNumber: dataTow.orderNo,
                      status:dataTow.status
                    },
                  });
                },
                fail: function (res) {
                  console.log("res----", res);
                },
                cancel: function (res) {
                  console.log("支付验证err", res);
                },
              });
            });
            wx.error(function (res) {
              console.log("res失败", res);
            });
          } else {
            window.location.href = res.data.payUrl;
          }
        }).catch(err => {
          alert("支付未知错误,请联系学习规划老师")
          this.awitType = false
        });
      } else {
        if (this.orderInfo.state == 2) {
          this.$router.push({
            path: "/payResult",
            query: {
              isPay: true,
            },
          });
          return;
        }
        this.$store.commit("Pay/editPayCid",this.$route.query.cid)
        let parmes = {
          orderNumber: this.orderInfo.orderNumber, //订单编号id
          cname: this.orderInfo.cname, //课程名称;
          discountPrice: this.orderInfo.discountPrice, //折后金额
          practicalPrice: this.orderInfo.discountPrice, //实际支付的金额
          aid: this.orderInfo.id, //活动id
          coupon: this.orderInfo.coupon, //优惠金额
        };
        if (getAppClient() == "JSAPI") {
          parmes.openid = this.wxOpendId;
        }

        // 删除
        let couponParme = CacheModule.getSessionStorage("couponParme");
        if (couponParme) {
          CacheModule.removeSessionStorage("couponParme");
        }
        let pid;
        if (getAppClient() == "JSAPI") {
          this.jsFlag = false;
          pid = 3;
        } else {
          pid = this.payFlag;
        }
        toPay(parmes, pid).then((res) => {
          this.awitType = false
          let data = res.data;
          let _this = this;
          if (getAppClient() == "JSAPI") {
            wx.ready(function () {
              wx.chooseWXPay({
                timestamp: data.timeStamp, // 支付签名时间戳，注意微信jssdk中的所有使用timestamp字段均为小写。但最新版的支付后台生成签名使用的timeStamp字段名需大写其中的S字符
                nonceStr: data.nonceStr, // 支付签名随机串，不长于 32 位
                package: data.package, // 统一支付接口返回的prepay_id参数值，提交格式如：prepay_id=***）
                signType: data.signType, // 签名方式，默认为'SHA1'，使用新版支付需传入'MD5'
                paySign: data.paySign, // 支付签名
                success: function () {
                  _this.$router.push({
                    path: "/payResult",
                    query: {
                      isPay: true,
                    },
                  });
                },
                fail: function (res) {
                  console.log("res----", res);
                },
                cancel: function (res) {
                  console.log("支付验证err", res);
                },
              });
            });
            wx.error(function (res) {
              console.log("res失败", res);
            });
          } else {
            window.location.href = res.data.payUrl;
          }
        });
      }
    },
    goHome() {
      this.$router.push({
        path: "/index",
      });
    },
    payClick(e) {
      this.payFlag = e;
    },
    selectCp() {
      this.$router.push({
        path: "/selectCoupon",
        query: {
          cid: this.$route.query.cid,
        },
      });
    },
  },
};
</script>
<style scoped lang="less">
.payImg {
  width: 45/20rem;
  height: 16/20rem;
}
.couponNum {
  width: 45/20rem;
  height: 16/20rem;
  line-height: 16/20rem;
  top: 0;
  left: 0;
}
.paylist {
  height: 50/20rem;
}
.defbg {
  background: #fff;
  color: #222;
}
.bgff {
  background: rgba(255, 242, 230, 1);
  color: #f08243;
}
.iconBox {
  width: 28/20rem;
  height: 28/20rem;
}
.radioImg {
  width: 19/20rem;
  height: 19/20rem;
}
.fixBox {
  height: 54/20rem;
}
.fixedBtn {
  position: fixed;
  bottom: 0;
  box-sizing: border-box;
  left: 0;
  width: 100%;
  box-shadow: 0px 0px 1px 0px rgba(0, 0, 0, 0.1);
  // height: 54/20rem;
  .buyBtn {
    width: 7rem;
    line-height: 54/20rem;
    background: rgba(240, 131, 68, 1);
  }
  .consult {
    width: 64/20rem;
    height: 54/20rem;
    border-left: 1px solid #f1f1f1;
    .consultImg {
      width: 1rem;
      height: 1rem;
    }
  }
}
.red {
  color: #eb1616;
}
.payTitle {
  height: 68/20rem;
}
.lineF4 {
  height: 5/20rem;
  background: rgba(244, 244, 244, 1);
}
.couponBox {
  height: 50/20rem;
}
</style>
